<p-dialog
  header="Header"
  [modal]="true"
  [(visible)]="visible"
  [style]="{ width: '95%', 'max-width': '700px', 'max-height': 'calc(100vh - 10rem)' }"
  (onHide)="closeDialog()"
>
  <ng-template pTemplate="header">
    <div class="header">
      <div class="title">{{ title }}</div>
      <div class="icon-group">
        <i class="icon pi pi-expand" (click)="onFitToScreen()"></i>
        <i class="icon pi pi-plus" (click)="onIncreaseFontSize()"></i>
        <i class="icon pi pi-minus" (click)="onDecreaseFontSize()"></i>
      </div>
    </div>
  </ng-template>
  <pre
    [ngStyle]="{
      'font-size': fontSizePx.toFixed(1) + 'px',
      'line-height': '17px',
      display: 'flex',
      'flex-direction': 'column',
      'align-items': 'flex-start',
      'justify-content': 'flex-start'
    }"
  >
    @for (line of lines; track $index) {
    <div style="font-family: Inconsolata, monospace; font-weight: 500;">{{ line }}</div>
    }
</pre>
</p-dialog>
